/* eslint-disable */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { firebaseConnect, isLoaded } from 'react-redux-firebase';
import { AppView, CreatorDocumentS } from 'medua-components';

@firebaseConnect()
@translate(['schools', 'actions'])
export default class SchoolDescription extends Component {
  constructor(props) {
		super(props);

    this.state = {
      value: props.user && props.user.school && props.user.school.description ? props.user.school.description : '<h1>Wählen Sie eine Überschrift</h1><p>Aktivieren Sie unten den Bearbeitungsmodus und beschreiben Sie ihre Schule</p>',
      readOnly: true
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleLock = this.handleLock.bind(this);
  }

  handleOnChange(value) {
    this.setState({ value });
  }

  handleOnBlur(value) {
    this.setState({ value });
  }

  handleLock() {
    if (this.state.readOnly) {
      this.setState({ readOnly: false })
    } else {
      this.setState({ readOnly: true })
      if (this.state.value.localeCompare(this.props.user.school.description) != 0) {
        this.props.firebase.update(
          `schools/${this.props.account.school.id}`, {
            description: this.state.value
        })
        // toast.success("Saved!")
      }
    }
  }

	render() {
    const { user } = this.props
    let button
    if (this.state.readOnly) {
      button = { text: this.props.t('actions:text.edit'), action: this.handleLock }
    } else {
      if ((user && !user.school.description) || (user && this.state.value.localeCompare(user.school.description) != 0)) {
        button = { type: 'success', text: this.props.t('actions:text.save'), action: this.handleLock }
      } else {
        button = { text: this.props.t('actions:text.close'), action: this.handleLock }
      }
    }
		return (
      <AppView
        loading={ !isLoaded(user) }
        headerSize="small"
        color="dark"
        title={ this.props.t('schools:description.title') }
        buttons={[
          button
        ]}
      >
        <CreatorDocumentS
          readOnly={this.state.readOnly}
          value={this.state.value}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
        />
      </AppView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/school/description/index.jsx